import { enumKeysToArray } from '@/utils/enum'
import { makeServicesTypes } from '@/core/container/makeServicesTypes'

export enum NOTE_FEED_SERVICES {
  NoteFeedService,
  NoteFeedRepository,
  NoteFeedStatsService,
  NoteFeedStatsRepository,
  NoteFeedGridable,
  NoteFeedFilterServiceFactory,
  NotesScopeService,
  NotesScopeRepository,
  NoteFeedScopeResolver,
}

export type NoteFeedServices = keyof typeof NOTE_FEED_SERVICES

export const NOTE_FEED_SERVICE_TYPES: Record<NoteFeedServices, symbol> = makeServicesTypes<NoteFeedServices>(
  enumKeysToArray<NoteFeedServices>(NOTE_FEED_SERVICES),
)
